import { FormattedMessage } from 'react-intl';

import { ConfigStepBody } from './config-step/config-step';
import { fieldsTranslations, messages } from './messages';
import { ImportType } from '../../../../../../components/csv-import/data/types/import-type';
import { StepType } from '../../../../../../components/csv-import/data/types/step-type';
import { ImportProvider } from '../../../../../../components/csv-import/ui/components/import-context';
import { SingleImportDrawer } from '../../../../../../components/csv-import/ui/components/single-import-drawer/single-import-drawer';
import { ConfigStepFooter } from '../../../../../../components/csv-import/ui/components/steps/create-config-step/create-config-step';
import { CreateMappingStepBody } from '../../../../../../components/csv-import/ui/components/steps/create-mapping-step/create-mapping-step';
import { CreateMappingStepFooter } from '../../../../../../components/csv-import/ui/components/steps/create-mapping-step/create-mapping-step-footer';
import {
  ImportIsProcessingStepBody,
  ImportIsProcessingStepFooter,
} from '../../../../../../components/csv-import/ui/components/steps/import-is-processing-step/import-is-processing-step';
import { getTranslationFn } from '../../../../../../components/csv-import/ui/utils';
import { CSV_BLACKLIST_IMPORT_JOB_COMPLETE } from '../../../../../../services/pusher-service/pusher-contract-messages';
import { Workflows } from '../../../../../../tracking/tracking-constants';
import { WorkflowSteps } from '../../../../../../tracking/use-workflow-tracking';

type BlacklistImportDrawerProps = {
  onClose: () => void;
  trackProcess: (workflowStep: string, metadata?: Record<string, unknown>) => void;
};

const steps = [
  {
    id: StepType.CREATE_CONFIG,
    title: <FormattedMessage {...messages.createConfigStep} />,
    body: <ConfigStepBody />,
    footer: <ConfigStepFooter />,
  },
  {
    id: StepType.CREATE_MAPPING,
    title: <FormattedMessage {...messages.createMappingStep} />,
    body: <CreateMappingStepBody />,
    footer: <CreateMappingStepFooter />,
  },
  {
    id: StepType.IMPORT_IS_PROCESSING,
    title: <FormattedMessage {...messages.importResult} />,
    body: (
      <ImportIsProcessingStepBody
        successMessage={<FormattedMessage {...messages.importResultSuccess} />}
        title={<FormattedMessage {...messages.importResult} />}
      />
    ),
    footer: <ImportIsProcessingStepFooter />,
  },
];

const translateField = getTranslationFn(fieldsTranslations, ImportType.blacklist);

export const BlacklistImportDrawer = ({ onClose, trackProcess }: BlacklistImportDrawerProps) => {
  const onCancel = (step: string) => {
    return () => {
      onClose();
      trackProcess(WorkflowSteps.CANCEL, { step });
    };
  };

  return (
    <ImportProvider
      importType={ImportType.blacklist}
      onClose={onCancel(StepType.IMPORT_IS_PROCESSING)}
      pusherEvent={CSV_BLACKLIST_IMPORT_JOB_COMPLETE}
      trackProcess={trackProcess}
      translateField={translateField}
      workflowType={Workflows.CSV_BLACKLIST_IMPORT_FLOW}
    >
      <SingleImportDrawer header={<FormattedMessage {...messages.modalDrawer} />} onCancel={onCancel} steps={steps} />
    </ImportProvider>
  );
};
